import gqlmin from 'gqlmin'

function V1GetCart(userId: number): string {
  return gqlmin(`
    query {
      V1GetCart(user_id: ${userId}) {
        result {
          id
          total_price
          on_daily_deals {
            campaign_id
            event_name
            dailydeals_serial
            campaign_detail_id
          }
          detail {
            id
            name
            microsite_url
            details {
              alias
              item_name
              id_item
              default_image
              product_quantity
              minimum_order
              maximum_order
              product_price_subtotal
              prices {
                price
                discount
                quantity_end
              }
              campaign {
                max_buy_qty
                remaining_stock
              }
              is_stock_available
              stock_type
              available_stock
            }
          }
          cart_analytics {
            item_id
            item_name
            currency
            discount
            item_brand
            item_category
            item_category2
            item_category3
            item_variant
            location_id
            price
            quantity
          }
        }
      }
    }
  `)
}

export default V1GetCart
